import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'sso-lti',
    components: {
    },
})

export default class SSOLti extends Vue {
    @Prop()
    private ssoDetails: any;

    private ssoFields: any = {
        clientId: {
            name: 'oAuth2 Client Id',
            field: 'b-form-input',
            modelKey: 'clientId',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        deploymentId: {
            name: 'Deployment Id',
            field: 'b-form-input',
            modelKey: 'deploymentId',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        oidcurl: {
            name: 'Platform OIDC URL',
            field: 'b-form-input',
            modelKey: 'oidcurl',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        issuer: {
            name: 'Issuer',
            field: 'b-form-input',
            modelKey: 'issuer',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        jwksurl: {
            name: 'JWKS URL',
            field: 'b-form-input',
            modelKey: 'jwksurl',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
    };

    private ltiURL: any = {
        'JWKS URL' : 'https://<env>/api/nucleus-lti/v1/lti/jwks',
        'Login init URL' : 'https://<env>/api/nucleus-lti/v1/login/init',
        'Launch URL' : 'https://<env>/api/nucleus-lti/v1/lti/v1p3/launch',
        'Deeplink Launch Library' : 'https://<env>/api/nucleus-lti/v1/lti/v1p3/deeplinking/library/launch',
        'Deeplink Launch Class' : 'https://<env>/api/nucleus-lti/v1/lti/v1p3/deeplinking/clasroom/launch',
    };

    private ltiData: any = ['JWKS URL', 'Login init URL',
    'Launch URL', 'Deeplink Launch Library', 'Deeplink Launch Class'];

    public async copyToClipboard() {
        let text = JSON.stringify(this.ltiURL);
        text = text.substring(1);
        text = text.substring(0, text.length - 1);
        try {
           await navigator.clipboard.writeText(text);
         } catch ($e) {
           const doNothing = '';
         }
     }
}
